import React, { useState } from "react";
import { Table, Button, Space } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import StickerPackModal from "../../../components/modal/sticker/StickerPackModal";
import StickerPackStickersModal from "../../../components/modal/sticker/StickerPackStickersModal";
import useStickerPacks from "../../../hooks/useStickerPacks";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import ThumbnailSticker from "./ThumbnailSticker";

export default function StickerPackTable() {
    const {
        packs,
        loading,
        pagination,
        fetchStickerPacks,
        createPack,
        updatePack,
        deletePack,
    } = useStickerPacks();

    const [editingPack, setEditingPack] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPack, setSelectedPack] = useState(null);
    const [isStickerModalOpen, setIsStickerModalOpen] = useState(false);
    const [isDeletePackModalOpen, setIsDeletePackModalOpen] = useState(false);
    const [stickerPackId, setStickerPackId] = useState(null);

    const handleSubmit = async (values, packId) => {
        if (packId) await updatePack({packId, ...values});
        else await createPack(values);
        setIsModalOpen(false);
    };

    const handleDelete = async () => {
        if (!stickerPackId) return;
        await deletePack(stickerPackId);
    };

    const columns = [
        {
            title: "",
            dataIndex: "thumbnailResourceId",
            key: "thumbnailResourceId",
            width: 80,
            render: (thumbnailResourceId) =>
                thumbnailResourceId ? (
                    <ThumbnailSticker thumbnailResourceId={thumbnailResourceId}/>
                ) : (
                    <div style={{width: 50, height: 50, background: "#f0f0f0"}}/>
                ),
        },
        {
            title: "Pack Name",
            dataIndex: "name",
            key: "name",
            width: 350,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            ellipsis: true,
        },
        {
            title: "Actions",
            key: "action",
            width: 250,
            render: (_, record) => (
                <Space>
                    <Button
                        type="link"
                        icon={<EditOutlined/>}
                        onClick={(e) => {
                            e.stopPropagation();
                            setEditingPack(record);
                            setIsModalOpen(true);
                        }}
                    >
                        Edit
                    </Button>
                    <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined/>}
                        onClick={(e) => {
                            e.stopPropagation();
                            setStickerPackId(record?.packId);
                            setIsDeletePackModalOpen(true);
                        }}
                    >
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="flex justify-end items-center mb-3">
                <Button
                    type="primary"
                    icon={<PlusOutlined/>}
                    onClick={() => {
                        setEditingPack(null);
                        setIsModalOpen(true);
                    }}
                >
                    Create Pack
                </Button>
            </div>

            <Table
                size="middle"
                columns={columns}
                dataSource={packs}
                rowKey="packId"
                loading={loading}
                pagination={{
                    ...pagination,
                    showSizeChanger: false,
                    onChange: (page, pageSize) => fetchStickerPacks(page, pageSize),
                }}
                onRow={(record) => ({
                    onClick: () => {
                        setSelectedPack(record);
                        setIsStickerModalOpen(true);
                    },
                })}
            />

            {isModalOpen && <StickerPackModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSubmit={handleSubmit}
                editingPack={editingPack}
            />}

            {selectedPack && <StickerPackStickersModal
                open={isStickerModalOpen}
                onClose={() => setIsStickerModalOpen(false)}
                pack={selectedPack}
            />}

            {isDeletePackModalOpen && <GeneralModal
                title={"Delete Sticker Pack"}
                content={"Are you sure to delete this pack?"}
                onCancel={() => setIsDeletePackModalOpen(false)}
                open={isDeletePackModalOpen}
                onConfirm={handleDelete}
            />
            }
        </div>
    );
}
